import { useEffect } from "react";
import { isMobileOnly } from "react-device-detect";
import { useTranslation } from "react-i18next";
import { ContentTop } from "common/src/component/ContentTop";
import GameTransactions from "common/src/component/GameTransactions";
import {
  AccountContainer,
  AccountDescription,
  AccountHeader,
  PageContent,
  PageContentWrapper,
  StyledCol,
} from "common/src/styledComponents/AccountPage";

const CasinoHistory = ({
  playerCurrency,
  serverSetup,
  pages,
  server,
  skin,
}) => {
  const { t } = useTranslation("");
  useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
      });
    };
    scrollToTop();
  }, []);

  return (
    <>
      <ContentTop
        serverSetup={serverSetup}
        showProfileMenu={!isMobileOnly}
        pages={pages}
        skin={skin}
      />
      <PageContent>
        <PageContentWrapper>
          <AccountContainer history>
            <StyledCol>
              {skin !== "pub" && (
                <AccountHeader>
                  {t("label_casino_history_header")}
                </AccountHeader>
              )}
              <AccountDescription
                dangerouslySetInnerHTML={{
                  __html: t(
                    "label_casino_history_description",
                    "label_casino_history_description"
                  ),
                }}
              ></AccountDescription>
              <GameTransactions
                playerCurrency={playerCurrency}
                server={server}
              />
            </StyledCol>
          </AccountContainer>
        </PageContentWrapper>
      </PageContent>
    </>
  );
};

export default CasinoHistory;
